'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Custom Decorators


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _milanoteForm = require('../../../components/form/milanoteForm');

var _milanoteForm2 = _interopRequireDefault(_milanoteForm);

var _FullScreenModal = require('../../../components/modal/FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Form = require('../../../components/form/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FormInput = require('../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _validationConstants = require('../../../../common/validation/validationConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ForgottenPasswordInputModal = (_dec = (0, _milanoteForm2.default)({ form: 'forgotPassword', fieldsConfig: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS }), _dec(_class = function (_React$Component) {
    _inherits(ForgottenPasswordInputModal, _React$Component);

    function ForgottenPasswordInputModal() {
        _classCallCheck(this, ForgottenPasswordInputModal);

        return _possibleConstructorReturn(this, (ForgottenPasswordInputModal.__proto__ || Object.getPrototypeOf(ForgottenPasswordInputModal)).apply(this, arguments));
    }

    _createClass(ForgottenPasswordInputModal, [{
        key: 'componentDidMount',

        /**
         * Focuses the email input field when the page loads.
         */
        value: function componentDidMount() {
            this.refs.email.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                submitInterceptor = _props.submitInterceptor,
                sanitisedErrors = _props.sanitisedErrors,
                submitting = _props.submitting,
                showingErrors = _props.showingErrors;


            return _react2.default.createElement(
                _FullScreenModal2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'logo' },
                    _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'heading' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Reset your password'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section' },
                    _react2.default.createElement(
                        _Form2.default,
                        { className: (0, _classnames2.default)('auth-form form', { submitting: submitting }), onSubmit: submitInterceptor,
                            noValidate: true },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'field-info' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'field-label', htmlFor: 'email' },
                                    'Your email'
                                ),
                                _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.email })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'field-row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'field' },
                                    _react2.default.createElement(_FormInput2.default, _extends({}, this.props, { ref: 'email',
                                        name: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS.email.name,
                                        type: _validationConstants.REQUEST_PASSWORD_RESET_FIELDS.email.type,
                                        placeholder: 'you@domain.com' }))
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _FormButton2.default,
                            { type: 'submit', className: 'row primary', disabled: submitting || showingErrors },
                            'Request reset link'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'section secondary' },
                    _react2.default.createElement(
                        'div',
                        { className: 'return-to-login' },
                        'Go back to the \xA0',
                        _react2.default.createElement(
                            'a',
                            { href: '/login', onClick: this.props.navigateToLogin },
                            'Log in screen'
                        )
                    )
                )
            );
        }
    }]);

    return ForgottenPasswordInputModal;
}(_react2.default.Component)) || _class);


ForgottenPasswordInputModal.propTypes = {
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    navigateToLogin: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object
};

exports.default = ForgottenPasswordInputModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/forgottenPassword/ForgottenPasswordInputModal.js
// module id = 1677
// module chunks = 0